import { styled } from '@mui/material';

export const StyledGreenSpan = styled('span')(({ theme }) => ({
  color: theme.palette.green.main,
}));
